
import { i18nText } from '@/locales';

import {Component, Prop, Vue} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {MONTHS, YEARS} from "@/utils";
import moment from "moment";
import StaffScheduleAddForm from "@/form/staff/schedule/add";
import StaffScheduleUpdateForm from "@/form/staff/schedule/update";
import {StaffScheduleAddRequestType} from "@/form/staff/schedule/add.types";
import {StaffScheduleUpdateRequestType} from "@/form/staff/schedule/update.types";
import {StaffScheduleStore} from "@/store/modules/Staff/Schedule";
import {IStaffScheduleListItem} from "@/entity/staff/schedule.types";
import {IWorkersListItem} from "@/entity/workers/workers.types";
import {message} from "ant-design-vue";

@Component({
  components: {PageTitle}
})
export default class WorkerSchedule extends Vue {
  months = MONTHS;
  years = YEARS;
  year: string = '';
  id: number | null = 0;
  month = 0;
  visible = false;
  tabValue = 1;
  timeStart: any = null;
  timeEnd: any = null;
  timeBreakStart: any = null;
  timeBreakEnd: any = null;
  showBreak = false;
  @Prop() readonly worker!: IWorkersListItem | null;
  form = new StaffScheduleAddForm();
  updateForm = new StaffScheduleUpdateForm();
  dateForModal = "123";

  constructor() {
    super();
  }

  dayValue = '';

  dayValueEdit(): string {
    // var timeoutId = setTimeout(() => {

      const day = (new Date(this.dayValue)).getDate();
  
      let month = this.month < 10 ? '0' + this.month : this.month;
      return (day < 10 ? '0' + day : day) + '.' + month + '.' + parseInt(this.year);
    // }, 4000);
  }

  onPanelChange(value: any, mode: any): void {
    this.year = value.year();
    this.month = value.month() + 1;
    this.fetchStaffSchedule();
  }

  hideModal(): void {
    this.visible = false;
    this.showBreak = false;
    this.$forceUpdate();
  }

  onEdit(action: any): void {
    console.log(action);
  }

  onSelect(value: any): void {
    this.id = 0;
    this.timeBreakStart = null;
    this.timeBreakEnd = null;
    this.dayValue = value._d.toString();
    this.tabValue = 1;

    this.dateForModal = this.dayValueEdit();
    if (!this.visible) {
      this.visible = true;
    } else {
      this.showBreak = false;
    }

    if (!this.form) this.form = new StaffScheduleAddForm();
    // let salonWorkDate = this.year + '-' + this.month + '-' + (new Date(this.dayValue)).getDate();

    // this.timeStart = moment(salonWorkDate + ' ' + StaffScheduleStore.default_from)
    // this.timeEnd = moment(salonWorkDate + ' ' + StaffScheduleStore.default_to)

    let salonWorkDate = (new Date(this.dayValue)).getDate() + '-' + this.month + '-' + this.year
    this.timeStart = moment(salonWorkDate + ' ' + StaffScheduleStore.default_from, 'DD/MM/YYYY HH:mm:ss')
    this.timeEnd = moment(salonWorkDate + ' ' + StaffScheduleStore.default_to, 'DD/MM/YYYY HH:mm:ss')

    if (this.visible && this.staffSchedule) {
      for (let i = 0; i < this.staffSchedule.length; i++) {
        let month = this.staffSchedule[i].month < 10 ? '0' + this.staffSchedule[i].month : this.staffSchedule[i].month;
        let curData = this.staffSchedule[i].day + '-' + month + '-' + this.staffSchedule[i].year

        const day = (new Date(this.dayValue)).getDate();
        let targetMonth = this.month < 10 ? '0' + this.month : this.month
        let targetData = day + '-' + targetMonth + '-' + parseInt(this.year);

        if (targetData === curData) {
          this.id = this.staffSchedule[i].id;

          if (this.staffSchedule[i].working_day) {
            this.timeStart = moment(curData + ' ' + this.staffSchedule[i].work_start, 'DD/MM/YYYY HH:mm:ss');
            this.timeEnd = moment(curData + ' ' + this.staffSchedule[i].work_finish, 'DD/MM/YYYY HH:mm:ss');

            if (this.staffSchedule[i].break_start && this.staffSchedule[i].break_finish) {
              this.showBreak = true;
              let break_start = this.staffSchedule[i].break_start!.substr(0, 5);
              let break_finish = this.staffSchedule[i].break_finish!.substr(0, 5);

              this.timeBreakStart = moment(curData + ' ' + this.staffSchedule[i].break_start, 'DD/MM/YYYY HH:mm:ss');
              this.timeBreakEnd = moment(curData + ' ' + this.staffSchedule[i].break_finish, 'DD/MM/YYYY HH:mm:ss');
            }
          } else {
            this.tabValue = 2;
          }
        }
      }
    }
    this.$forceUpdate();
  }

  getDayData(value: any): string[] {

    let data: string[] = [];
    if (this.staffSchedule) {
      for (let i = 0; i < this.staffSchedule.length; i++) {
        let month = this.staffSchedule[i].month < 10 ? '0' + this.staffSchedule[i].month : this.staffSchedule[i].month;
        let day = this.staffSchedule[i].day < 10 ? '0' + this.staffSchedule[i].day : this.staffSchedule[i].day;
        let curData = this.staffSchedule[i].year + '-' + month + '-' + day;

        if (value.format('YYYY-MM-DD') === curData && this.staffSchedule[i].working_day) {
          let work_start = this.staffSchedule[i].work_start!.substr(0, 5);
          let work_finish = this.staffSchedule[i].work_finish!.substr(0, 5);
          data = [
            work_start + '-' + work_finish,
          ];

          if (this.staffSchedule[i].break_start && this.staffSchedule[i].break_finish) {
            let break_start = this.staffSchedule[i].break_start!.substr(0, 5);
            let break_finish = this.staffSchedule[i].break_finish!.substr(0, 5);

            data.push(break_start + '-' + break_finish);
          }
        }
      }
    }

    return data;
  }

  async saveSchedule(): Promise<void> {

    if (this.worker !== null) {

      await this.proceed();
      await this.fetchStaffSchedule();
      //this.$forceUpdate();
    }

  }

  async proceed(): Promise<void> {
    if (this.worker !== null) {
      if (!this.timeStart || !this.timeEnd) {
        if (this.tabValue === 1) {
          message.error(i18nText("Укажите время"))
          return;
        } else {
          this.visible = false
          this.$forceUpdate();
        }
      }
      const day = (new Date(this.dayValue)).getDate();
      const timeStart = new Date(this.timeStart);
      const timeEnd = new Date(this.timeEnd);

      const timeBreakStart = this.timeBreakStart ? new Date(this.timeBreakStart) : null;
      const timeBreakEnd = this.timeBreakStart ? new Date(this.timeBreakEnd) : null;

      const hoursStart = timeStart.getHours() < 10 ? '0' + timeStart.getHours() : timeStart.getHours();
      const hoursEnd = timeEnd.getHours() < 10 ? '0' + timeEnd.getHours() : timeEnd.getHours();
      const minutesStart = timeStart.getMinutes() < 10 ? '0' + timeStart.getMinutes() : timeStart.getMinutes();
      const minutesEnd = timeStart.getMinutes() < 10 ? '0' + timeStart.getMinutes() : timeStart.getMinutes();

      const work_start = hoursStart + ':' + minutesStart;
      const work_finish = hoursEnd + ':' + minutesEnd;

      let break_start = null;
      let break_finish = null;

      if (timeBreakStart && timeBreakEnd) {
        const breakHoursStart = timeBreakStart.getHours() < 10 ? '0' + timeBreakStart.getHours() : timeBreakStart.getHours();
        const breakHoursEnd = timeBreakEnd.getHours() < 10 ? '0' + timeBreakEnd.getHours() : timeBreakEnd.getHours();
        const breakMinutesStart = timeBreakStart.getMinutes() < 10 ? '0' + timeBreakStart.getMinutes() : timeBreakStart.getMinutes();
        const breakMinutesEnd = timeBreakEnd.getMinutes() < 10 ? '0' + timeBreakEnd.getMinutes() : timeBreakEnd.getMinutes();
        break_start = breakHoursStart + ':' + breakMinutesStart;
        break_finish = breakHoursEnd + ':' + breakMinutesEnd;
      }

      let status: boolean;

      if (!this.id) {
        const data: StaffScheduleAddRequestType = {
          staff_id: this.worker.id,
          month: this.month,
          year: parseInt(this.year),
          day: day,
          working_day: this.tabValue == 1,
          work_start: work_start,
          work_finish: work_finish,
          break_start: break_start,
          break_finish: break_finish,
        };
        this.form.setFormData(data);
        status = await this.form.submit(StaffScheduleStore.create);
      } else {
        const data: StaffScheduleUpdateRequestType = {
          id: this.id,
          month: this.month,
          year: parseInt(this.year),
          day: day,
          working_day: this.tabValue == 1,
          work_start: work_start,
          work_finish: work_finish,
          break_start: break_start,
          break_finish: break_finish,
        };
        this.updateForm.setFormData(data);
        status = await this.updateForm.submit(StaffScheduleStore.update);
      }

      if(status) {
        this.visible = false;
        //this.$forceUpdate();
        this.showBreak = false;
      }

    }
  }

  get staffSchedule(): IStaffScheduleListItem[] | null {
    return StaffScheduleStore.items;
  }

  async fetchStaffSchedule(): Promise<void> {
    if (this.worker !== null) {

      await StaffScheduleStore.fetchAll({
        filter: {
          staff_id: this.worker.id,
          month: this.month,
          year: this.year,
          //working_day: true
        }
      });
    }
  }

  async created(): Promise<void> {

    const currentYear = this.years.find(el => el === new Date().getFullYear().toString());
    this.year = currentYear ? currentYear : '';

    const currentMonth = this.months.find(el => el.id === new Date().getMonth());
    this.month = currentMonth ? currentMonth?.id + 1 : 1;

    await this.fetchStaffSchedule();
  }
}
